/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：140
 */

"use strict"

export { o as a }
import * as /* [auto-meaningful-name] */Module_362 from /* 362 */"./362"
import * as /* [auto-meaningful-name] */Module_388 from /* 388 */"./388"
function o(e) {
  var t = function () {
    if ("undefined" === typeof Reflect || !Reflect.construct) {
      return false
    }
    if (Reflect.construct.sham) {
      return false
    }
    if ("function" === typeof Proxy) {
      return true
    }
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}))
      return true
    } catch (e) {
      return false
    }
  }()
  return function () {
    var n
    var o = Module_362.a(e)
    if (t) {
      var /* [auto-meaningful-name] */Module_362$aThis$constructor = Module_362.a(this).constructor
      n = Reflect.construct(o, arguments, Module_362$aThis$constructor)
    } else {
      n = o.apply(this, arguments)
    }
    return Module_388.a(this, n)
  }
}
export default o
